import React, { useEffect, useState } from "react"
import { CardBody, Card } from "reactstrap"
import toast from "react-hot-toast"
import * as Yup from "yup"

import { DataTable } from "components/DataTable"
import ActionEyeIcon from "assets/images/icons/feather-eye-icon.png"
import { Pagination } from "components/Pagination"
import { Modal } from "components/Modal"
import { SearchBox } from "components/SearchBox"
import { AutoComplete } from "components/AutoComplete"
import { useLocalPaginatedRequest } from "hooks/useLocalPaginatedRequest"
import {
   CountsheetListing,
   CreateItemAudit,
   GetDepartmentsListing,
} from "api/api.service"
import useAsyncSelect from "hooks/useAsyncSelect"
import ItemDetails from "./ItemDetails"
import { Formik } from "formik"
import autoCompleteStyles from "components/AutoComplete/autoCompleteStyles"
import { Button } from "components/Button"
import { updateObjCheckBox } from "utils/commonUtils"
import { TextInput } from "components/TextInput"
import CommitModal from "./Modal/WarehouseBulkCommitDetailModal"
import DepartmentBulkCommitDetailModal from "./Modal/DepartmentBulkCommitDetailModal"

const DATA_KEY = "data"
const TOTAL_KEY = "total"

const COLUMNS = {
   SKU_NO: "SKU No.",
   ITEM_NAME: "Item Name",
   AUDITS: "Audits",
   AUDIT: "Audit",
   ACTION: "Action",
   SELECT_ALL: "Select All",
   AUDIT_QUANTITY: "Audit Quantity",
   ACTUAL_QUANTITY: "Actual Quantity",
}
const initialModalValue = {
   isBulkCommit: false,
   isView: false,
   type: null,
}
const modalTypes = {
   BULK_COMMIT: "BULK_COMMIT",
   VIEW: "VIEW",
}

const Listing = () => {
   const [filters, setFilters] = useState(null)
   const [selectedItemToView, setSelectedItemToView] = useState("")
   const [modalDataList, setModalDataList] = useState([])
   const [isSelectAll, setIsSelectAll] = useState(false)
   const [modalStates, setModalStates] = useState(initialModalValue)
   const {
      page,
      searchText,
      handleSearchChange,
      handlePageClick,
      pageSize,
      onChangePageSize,
      data,
      total,
      isFetching,
      request,
   } = useLocalPaginatedRequest({
      requestFn: CountsheetListing,
      params: {
         ...(filters?.length && { departmentId: filters }),
         auditCategory: "Department",
         limit: -1,
      },
      deps: [filters],
      dataKey: DATA_KEY,
      totalKey: TOTAL_KEY,
   })
   let dataLength = data?.length
   const departmentIds = filters ? filters.map(id => id) : []
   const {
      setSelectedOption: setSelectedStationOption,
      selectEntity: stationOptions,
      setSelectEntity: setStationsOption,
      handleSearchOnOptions: handleSearchStations,
      selectedOption: selectedStation,
      handleSelectAOption: handleSelectAStationOption,
   } = useAsyncSelect({
      apiFunc: GetDepartmentsListing,
      params: {
         limit: -1,
      },
      labelKey: "departmentName",
      valueKey: "id",
      onOptionSelect: option => {
         const ids = option.map(item => item.value)
         setFilters(ids)
      },
   })
   useEffect(() => {
      setIsSelectAll(false)
      setModalDataList([])
   }, [data])

   const handleCloseModal = () => {
      setModalStates(initialModalValue)
      setSelectedItemToView("")
   }

   const handleBulkCommit = () => {
      setModalStates({
         ...modalStates,
         isBulkCommit: true,
         type: modalTypes.BULK_COMMIT,
      })
   }
   const handleSelectedItem = item => {
      setSelectedItemToView(item)
      setModalStates({
         ...modalStates,
         isView: true,
         type: modalTypes.VIEW,
      })
   }
   const handleCheckBoxSelect = (e, item) => {
      const dataTemp = updateObjCheckBox(item, modalDataList, "itemsId")
      let filteredData = data.filter(el => el?.maxQuantity > 0)

      isSelectAll &&
         dataTemp.length !== filteredData.length &&
         setIsSelectAll(false)
      !isSelectAll &&
         dataTemp.length === filteredData.length &&
         setIsSelectAll(true)
      setModalDataList(dataTemp)
   }
   // select all handler
   const handleSelectAll = () => {
      let filteredData = data.filter(el => el.maxQuantity > 0)
      isSelectAll ? setModalDataList([]) : setModalDataList(filteredData)
      setIsSelectAll(!isSelectAll)
   }

   return (
      <>
         <Card className="mb-5">
            <CardBody className="p-2 p-md-4 wh-im-wh-gi-con">
               <div className="mb-3">
                  <div className="d-flex align-items-center justify-content-between admin-inventory-management-general-inventory-responsiveness ">
                     <div className="status-search-con wh-im-dpgi-status  me-2 ">
                        <AutoComplete
                           handleBlur={() =>
                              setStationsOption(prev => {
                                 return {
                                    ...prev,
                                    page: 1,
                                    Q: "",
                                 }
                              })
                           }
                           onChange={handleSelectAStationOption}
                           onInputChange={handleSearchStations}
                           placeholder="Select stations"
                           classNamePrefix="status-header-search-admin"
                           customStyles={autoCompleteStyles.STYLE_ONE}
                           options={stationOptions?.data}
                           value={selectedStation}
                           isLoading={stationOptions?.fetching}
                           maxMenuHeight={210}
                           isMulti
                        />
                     </div>
                     <div className="ad-location-search-box d-flex flex-row gap-3">
                        <Button
                           // isLoading={isLoading}
                           type={"submit"}
                           title={"Bulk Commit"}
                           className="header-button"
                           onClick={handleBulkCommit}
                           disabled={modalDataList?.length === 0}
                        />
                        <SearchBox
                           inputClasses="vendor-search-input input-search"
                           labelClass="d-none"
                           placeholder="Search"
                           searchIcon={true}
                           searchIconClass="vendor-table-search-icon"
                           conClass="vendor-table-search-inner-class"
                           searchText={searchText}
                           onChange={handleSearchChange}
                        />
                     </div>
                  </div>
               </div>
               <DataTable
                  data={data}
                  tableClasses="ad-warehouse-general-inventory-table"
                  loading={isFetching}
                  config={[
                     {
                        title: COLUMNS.SELECT_ALL,
                        selectAll: true,
                        selectAllClickHandler: handleSelectAll,
                        isSelectAll: isSelectAll,
                        isDisabled: !dataLength,
                        thClass: "checkbox-header",
                        tdClass: "checkbox-column",
                        className: "checkbox-column",
                        render: data => {
                           // if (userType != UserRoles.Finance) return

                           return (
                              <TextInput
                                 onClick={e => handleCheckBoxSelect(e, data)}
                                 labelClass="mb-0"
                                 type="checkbox"
                                 inputClass="form-check-input-custom fm-table-checkboxes "
                                 checked={
                                    modalDataList.length > 0
                                       ? modalDataList.filter(
                                            el => el.itemsId === data.itemsId
                                         ).length
                                       : false
                                 }
                                 disabled={data?.maxQuantity < 0}
                              />
                           )
                        },
                     },
                     {
                        title: COLUMNS.SKU_NO,
                        render: item => item.skuNo,
                     },
                     {
                        title: COLUMNS.ITEM_NAME,
                        render: item => item.itemName,
                     },
                     {
                        title: COLUMNS.ACTUAL_QUANTITY,
                        render: item => item?.totalActualQuantity,
                     },
                     {
                        title: COLUMNS.AUDIT_QUANTITY,
                        render: item => item?.totalAuditQuantity,
                     },

                     {
                        title: COLUMNS.AUDITS,
                        render: item => item.totalAudits,
                     },
                     {
                        title: COLUMNS.ACTION,
                        render: item => (
                           <img
                              src={ActionEyeIcon}
                              alt="view"
                              className="cursor-pointer"
                              onClick={() => handleSelectedItem(item)}
                           />
                        ),
                     },
                  ]}
               />
               <Pagination
                  currentPage={page}
                  totalData={total}
                  onPageClick={handlePageClick}
                  rowLimit={pageSize}
                  onChangePageSize={onChangePageSize}
               />
            </CardBody>
         </Card>
         {modalStates.isView && modalStates.type === modalTypes.VIEW && (
            <Modal
               isOpen={
                  modalStates.isView && modalStates.type === modalTypes.VIEW
               }
               handleModalToggling={handleCloseModal}
               sizeClasses="10"
               bodyClassName="p-0"
               customButton={true}
               hideModalHeaderSeparator={true}
               headerClasses="pb-0"
               className="inv-req-popup-viewdetails"
            >
               <ItemDetails
                  auditFor="Department"
                  itemsId={selectedItemToView.itemsId}
                  departmentId={filters}
                  name={"department"}
                  subKey={"departmentName"}
               />
            </Modal>
         )}

         {modalStates.isBulkCommit &&
            modalStates.type === modalTypes.BULK_COMMIT && (
               <DepartmentBulkCommitDetailModal
                  isOpen={
                     modalStates.isBulkCommit &&
                     modalStates.type === modalTypes.BULK_COMMIT
                  }
                  actionName="Save"
                  entityName="Bulk Commit"
                  toggleFunction={() => handleCloseModal()}
                  selectedItemsData={modalDataList}
                  departmentIds={departmentIds}
                  request={request}
               />
            )}
      </>
   )
}

export default Listing
